import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onChange, ...props }, ref) => {
  // Les inputs date natifs acceptent des années à 5-6 chiffres (« 62026 ») à la
  // saisie clavier : on ramène l'année aux 4 derniers chiffres tapés.
  const handleChange =
    type === "date" || type === "datetime-local"
      ? (e) => {
          const m = e.target.value.match(/^(\d{5,6})(-.*)$/);
          if (m) e.target.value = m[1].slice(-4) + m[2];
          onChange?.(e);
        }
      : onChange;
  return (
    <input
      type={type}
      onChange={handleChange}
      className={cn(
        "flex h-11 md:h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
